export default function isValidRegExpString(value) {
  if (typeof value === 'string') {
    try {
      const specialSymbols = /[*+?[\](){}^$|\\.]/;

      new RegExp(value);
      return specialSymbols.test(value);
    } catch (e) {
      if (e instanceof SyntaxError) {
        return false;
      } else {
        throw e;
      }
    }
  }
}
